export default __webpack_public_path__ + "static/media/1.59bc4eb0.jpg";